<div id="page-container" class="main-content-boxed">
    <!-- Main Container -->
    <main id="main-container">

        <!-- Page Content -->
        <div class="bg-image" style="background-image: url('https://source.unsplash.com/collection/1644882');">
            <div class="row mx-0 bg-black-op">
                

                <!-- quick summary -->
                <div class="hero-static col-md-6 col-xl-8 d-none d-md-flex align-items-md-end">
                    <div class="p-30 invisible" data-toggle="appear">
                        <p class="font-size-h3 font-w600 text-white">
                            Welcome to the Focus CRM
                        </p>
                        <p class="font-italic text-white-op">
                            Copyright &copy; <span class="js-year-copy">2018</span>
                        </p>
                    </div>
                </div>

                <!-- -->
                <div class="hero-static col-md-6 col-xl-4 d-flex align-items-center bg-white invisible" data-toggle="appear" data-class="animated fadeInRight">
                    <div class="content content-full">
                        <!-- Header -->
                        <div class="px-30 py-10">
                            
                                <img src="/assets/img/logo/logo.png" width="300" >
                                <!-- <i class="si si-fire"></i> -->
                                <!-- <span class="font-size-xl text-primary-dark">code</span><span class="font-size-xl">base</span> -->
                            <!-- <a class="link-effect font-w700" href=""></a>
                            </a> -->
                            <!-- <h1 class="h3 font-w700 mt-30 mb-10">Welcome to Your Dashboard</h1> -->
                            <h2 class="h5 font-w400 text-muted mt-30 mb-10">Please sign in using your Focus credentials</h2>
                        </div>
                        <!-- END Header -->

                        <router-outlet></router-outlet>
                        
                    </div>
                </div>
            </div>
        </div>
        <!-- END Page Content -->
    </main>
    <!-- END Main Container -->
</div>



// WEBPACK FOOTER //
// ./client/app/core/layout/public/public-layout.component.html